import {
  DISPOSITIVOPACIENTE_ERROR,
  DISPOSITIVOPACIENTE_LOADING,
  DISPOSITIVOPACIENTE_RESET,
  DISPOSITIVOPACIENTE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_LOADING,
  DISPOSITIVOPACIENTEDELETE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_LOADING,
  DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
  DISPOSITIVOPACIENTEAGREGAR_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_RESET,
  DISPOSITIVOPACIENTE_FLGVINCULADO,
  DISPOSITIVOPACIENTEDELETE_RESET,
  DISPOSITIVOPACIENTETRANSFERIR_LOADING,
  DISPOSITIVOPACIENTETRANSFERIR_SUCCESS,
  DISPOSITIVOPACIENTETRANSFERIR_ERROR,
  DISPOSITIVOPACIENTETRANSFERIR_RESET,
  DISPOSITIVOPACIENTEPREFERENCIAS_LOADING,
  DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS,
  DISPOSITIVOPACIENTEPREFERENCIAS_ERROR,
  DISPOSITIVOPACIENTEPREFERENCIAS_RESET,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetDispositivoPaciente = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_LOADING,
  });

  axiosLogin()
    .then((respuesta) => {
      respuesta
        .get("/shared/dispositivo-paciente")
        .then((res) => {
          dispatch({
            type: DISPOSITIVOPACIENTE_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: DISPOSITIVOPACIENTE_ERROR,
            payload: error,
          });
        });
    })
    .catch((err) => {
      console.error("[dispositivoPaciente] axiosLogin fallo:", err);
      dispatch({
        type: DISPOSITIVOPACIENTE_ERROR,
        payload: {
          detail: "Error al autenticar contra el servidor.",
          origen: "portal",
        },
      });
    });
};

export const wsPostDispositivoPaciente = (dtoDispositivo) => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEAGREGAR_LOADING,
  });

  axiosLogin()
    .then((respuesta) => {
      respuesta
        .post("/shared/dispositivo-paciente", dtoDispositivo)
        .then((res) => {
          dispatch({
            type: DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
            status: err.response?.status,
            statusText: err.response?.statusText,
          };

          dispatch({
            type: DISPOSITIVOPACIENTEAGREGAR_ERROR,
            payload: error,
          });
        });
    })
    .catch((err) => {
      console.error("[dispositivoPaciente] axiosLogin fallo:", err);
      dispatch({
        type: DISPOSITIVOPACIENTEAGREGAR_ERROR,
        payload: {
          detail: "Error al autenticar contra el servidor.",
          origen: "portal",
        },
      });
    });
};

export const wsDeleteDispositivoPaciente = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEDELETE_LOADING,
  });

  axiosLogin()
    .then((respuesta) => {
      respuesta
        .delete("/shared/dispositivo-paciente")
        .then((res) => {
          dispatch({
            type: DISPOSITIVOPACIENTEDELETE_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: DISPOSITIVOPACIENTEDELETE_ERROR,
            payload: error,
          });
        });
    })
    .catch((err) => {
      console.error("[dispositivoPaciente] axiosLogin fallo:", err);
      dispatch({
        type: DISPOSITIVOPACIENTEDELETE_ERROR,
        payload: {
          detail: "Error al autenticar contra el servidor.",
          origen: "portal",
        },
      });
    });
};

export const dispositivoPacienteReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_RESET,
  });
};

export const dispositivoPacienteFlgVinculadoSetTrue = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_FLGVINCULADO,
  });
};

export const dispositivoPacienteDeleteReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEDELETE_RESET,
  });
};

export const dispositivoPacientePostReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEAGREGAR_RESET,
  });
};

export const wsPostDispositivoPacienteTransferir = (dtoDispositivo) => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTETRANSFERIR_LOADING,
  });

  axiosLogin()
    .then((respuesta) => {
      respuesta
        .post("/shared/dispositivo-paciente/transferir", dtoDispositivo)
        .then((res) => {
          dispatch({
            type: DISPOSITIVOPACIENTETRANSFERIR_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
            status: err.response?.status,
            statusText: err.response?.statusText,
          };

          dispatch({
            type: DISPOSITIVOPACIENTETRANSFERIR_ERROR,
            payload: error,
          });
        });
    })
    .catch((err) => {
      console.error("[dispositivoPaciente] axiosLogin fallo:", err);
      dispatch({
        type: DISPOSITIVOPACIENTETRANSFERIR_ERROR,
        payload: {
          detail: "Error al autenticar contra el servidor.",
          origen: "portal",
        },
      });
    });
};

export const dispositivoPacienteTransferirReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTETRANSFERIR_RESET,
  });
};

export const wsPatchDispositivoPreferencias = (dtoPreferencias, next) => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEPREFERENCIAS_LOADING,
  });

  axiosLogin()
    .then((respuesta) => {
      respuesta
        .patch("/shared/dispositivo-paciente/preferencias", dtoPreferencias)
        .then((res) => {
          dispatch({
            type: DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS,
            payload: res.data,
          });
          if (next) next();
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
            status: err.response?.status,
            statusText: err.response?.statusText,
          };

          dispatch({
            type: DISPOSITIVOPACIENTEPREFERENCIAS_ERROR,
            payload: error,
          });
        });
    })
    .catch((err) => {
      console.error("[dispositivoPaciente] axiosLogin fallo:", err);
      dispatch({
        type: DISPOSITIVOPACIENTEPREFERENCIAS_ERROR,
        payload: {
          detail: "Error al autenticar contra el servidor.",
          origen: "portal",
        },
      });
    });
};

// ==========================================================================
// Versiones ASYNC (para el hook useDispositivoVinculacion refactorizado).
// Devuelven { data } o { error, status } en vez de dispatchear al reducer.
// El hook consume estas y llama al reducer solo para sincronizar la UI
// que depende del state (Perfil / toggle push).
// ==========================================================================

export const wsGetDispositivoPacienteAsync = async () => {
  const client = await axiosLogin();
  try {
    const res = await client.get("/shared/dispositivo-paciente");
    return { data: res.data };
  } catch (err) {
    return {
      error: err.response?.data,
      status: err.response?.status,
    };
  }
};

export const wsPostDispositivoPacienteAsync = async (dto) => {
  const client = await axiosLogin();
  try {
    const res = await client.post("/shared/dispositivo-paciente", dto);
    return { data: res.data };
  } catch (err) {
    return {
      error: err.response?.data,
      status: err.response?.status,
    };
  }
};

export const wsPostDispositivoPacienteTransferirAsync = async (dto) => {
  const client = await axiosLogin();
  try {
    const res = await client.post("/shared/dispositivo-paciente/transferir", dto);
    return { data: res.data };
  } catch (err) {
    return {
      error: err.response?.data,
      status: err.response?.status,
    };
  }
};

export const wsDeleteDispositivoPacienteAsync = async () => {
  const client = await axiosLogin();
  try {
    const res = await client.delete("/shared/dispositivo-paciente");
    return { data: res.data };
  } catch (err) {
    return {
      error: err.response?.data,
      status: err.response?.status,
    };
  }
};

export const wsPatchDispositivoPreferenciasAsync = async (dto) => {
  const client = await axiosLogin();
  try {
    const res = await client.patch("/shared/dispositivo-paciente/preferencias", dto);
    return { data: res.data };
  } catch (err) {
    return {
      error: err.response?.data,
      status: err.response?.status,
    };
  }
};

export const dispositivoPacientePreferenciasReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEPREFERENCIAS_RESET,
  });
};
